/**
 * Production SPA uses hash routing. Email clients and safe-link scanners often strip
 * `#/reset-password` from links, leaving `/reset-password?token=...` which the hash
 * router cannot read (empty hash → dashboard → login). Repair before Vue boots.
 */
export function repairPasswordResetUrlForHashRouting(): boolean {
  if (
    typeof window === 'undefined' ||
    !import.meta.env.PROD ||
    import.meta.env.VITE_HASH_ROUTING !== 'true'
  ) {
    return false
  }

  const { pathname, search, hash } = window.location
  if (!pathname.endsWith('/reset-password')) {
    return false
  }
  if (hash.includes('reset-password')) {
    return false
  }

  window.location.replace(`${window.location.origin}/#/reset-password${search}`)
  return true
}

export function readResetTokenFromLocation(): string {
  if (typeof window === 'undefined') return ''

  const hash = window.location.hash || ''
  const hashQueryIndex = hash.indexOf('?')
  if (hashQueryIndex >= 0) {
    const fromHash = new URLSearchParams(hash.slice(hashQueryIndex + 1)).get('token')
    if (fromHash?.trim()) return fromHash.trim()
  }

  const fromSearch = new URLSearchParams(window.location.search).get('token')
  return fromSearch?.trim() || ''
}
